import angular from 'angular';

const newsServices = angular.module('applicationModule.newsServices', []);


newsServices.factory('News', ['NewsAPI', 'AppsoupAPI', 'Upload', function (NewsAPI, AppsoupAPI, Upload) {
    'use strict';
    var API_URL = AppsoupAPI.API_URL + '/app/news/';

    var checkFiles = function (file) {
        var files = [];
        var names = [];
        if (angular.isDefined(file)) {
            files.push(file);
            names.push('file');
        }

        return {files: files, names: names};
    };

    return {
        getList: function (appId, params) {
            return NewsAPI.getAllNews(appId, params)
                .then(function (response) {
                    return response.data;
                });
        },
        get: function (newsId, appId) {
            return NewsAPI.getNews(newsId, appId);
        },
        save: function (news, editMode, file, filename) {
            return NewsAPI.storeNews(news, editMode, file, filename);
        },
        remove: function (newsId, appId) {
            return NewsAPI.removeNews(newsId, appId);
        },
        tags: function (appId, text) {
            return NewsAPI.getTags(appId, text);
        },
        uploadImage: function (news, file) {
            var files = checkFiles(file);
            if (angular.isDefined(file)) {
                return Upload.upload({
                    url: API_URL + 'upload-image',
                    method: 'POST',
                    sendObjectsAsJsonBlob: true,
                    fields: news,
                    file: files.files,
                    fileFormDataName: files.names
                });
            }
        },
        copy: function (newsId) {
            return NewsAPI.copy(newsId);
        },
        downloadFile: function (appId, newsId) {
            return NewsAPI.downloadFile(appId, newsId);
        },
        getAttributes: function (appId) {
            return NewsAPI.getAttributes(appId);
        },
        getLanguages: function () {
            return NewsAPI.getLanguages();
        },
        importTagCsv: function (appId, file, tag) {
            return NewsAPI.importTagCsv(appId, file, tag);
        },
        addTag: function (tag, news, appId) {
            return NewsAPI.addTag(tag, news, appId);
        },
        removeTag: function (tag, news, appId) {
            return NewsAPI.removeTag(tag, news, appId);
        },
        getCurrentUser: function () {
            return NewsAPI.getCurrentUser();
        }
    };
}]);

newsServices.service('NewsAPI', ['$http', 'AppsoupAPI', 'Upload', function ($http, AppsoupAPI, Upload) {
    'use strict';

    var API_URL = AppsoupAPI.API_URL + '/app/news/';

    this.getAllNews = function (appId, params) {
        return $http.get(API_URL, {params: angular.extend(AppsoupAPI.getTableParams(params), {application_id: appId})});
    };

    this.getNews = function (newsId, appId) {
        return $http.get(API_URL + 'edit/' + newsId + '/' + appId);
    };
    var checkFiles = function (file) {
        var files = [];
        var names = [];
        if (angular.isDefined(file)) {
            files.push(file);
            names.push('contractor_file');
        }

        return {files: files, names: names};
    };

    this.storeNews = function (news, editMode, file, filename) {
        if (file) {
            var files = checkFiles(file);
            var newfields = news;
            var url = API_URL + 'create';
            if (editMode) {
                newfields = angular.extend(news, {_method: 'PUT'});
                url = API_URL + 'store/' + news.id;
            }

            return Upload.upload({
                url: url,
                method: 'POST',
                sendObjectsAsJsonBlob: false,
                fields: newfields,
                file: files.files,
                fileFormDataName: files.names
            });
        }
        if (editMode) {
            news.removeFile = filename == null;

            return $http.put(API_URL + 'store/' + news.id, news);
        } else {
            return $http.post(API_URL + 'create', news);
        }
    };

    this.removeNews = function (newsId) {
        return $http.delete(API_URL + 'delete/' + newsId);
    };

    this.getTags = function (appId, text) {
        return $http.get(API_URL + 'tags/' + appId, {params: {search: text}});
    };

    this.copy = function (newsId) {
        return $http.get(API_URL + 'copy/' + newsId);
    };

    this.downloadFile = function (appId, newsId) {
        return $http.get(API_URL + 'download-file/' + appId + '/' + newsId);
    };

    this.getAttributes = function (appId) {
        return $http.get(API_URL + appId + '/attributes');
    };

    this.getLanguages = function () {
        return $http.get(API_URL + 'languages');
    };

    this.importTagCsv = function (appId, file, tag) {
        return Upload.upload({
            url: API_URL + appId + '/import-tag',
            method: 'POST',
            sendObjectsAsJsonBlob: false,
            fields: tag,
            file: file
        });
    };

    this.addTag = function (tag, news, appId) {
        return $http.post(API_URL + 'add-tag', {tag: tag, news: news, appId: appId});
    };

    this.removeTag = function (tag, news, appId) {
        return $http.post(API_URL + 'remove-tag', {tag: tag, news: news, appId: appId});
    };

    this.getCurrentUser = function () {
        return $http.get(AppsoupAPI.API_URL + '/user/current');
    };

}]);

export default newsServices;
